<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<div mat-dialog-container>
  <div mat-dialog-title>
    &nbsp;
    <button
      mat-icon-button
      (click)="handleEditComplete(false)"
      title="Cancel"
      class="close-button"
      tabindex="-1"
      >
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (data && data.card) {
    <div mat-dialog-content>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [(ngModel)]="data.card.name" placeholder="Name">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Card Description</mat-label>
            <input type="text" matInput [(ngModel)]="data.card.description" placeholder="Card Description">
          </mat-form-field>
        </div>
      </div>
      @if (!data.card.isTemplate) {
        <div class="add-margin">
          <div>
            <mat-form-field class="full-width">
              <mat-label>Move</mat-label>
              <mat-select placeholder="Move" [(ngModel)]="data.card.move">
                @for (move of data.moveList; track move) {
                  <mat-option [value]="move.moveNumber" title="{{ move.description}}">
                    {{ move.moveNumber }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
    </div>
  }
  <div class="cssLayoutRowStartCenter bottom-button">
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" style="margin-left: 40px;">Save</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
